import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-audio-player-pause';
export var ID = 'icon-audio-player-pause';
/* eslint-disable max-len */

export var SVGAudioPlayerPause = function SVGAudioPlayerPause() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 30 30"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15",
    fill: "#FF893E"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M9 8h4.286v14H9V8zm7.714 0H21v14h-4.286V8z"
  })));
};
/* eslint-disable max-len */

var AudioPlayerPause = function AudioPlayerPause(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGAudioPlayerPause
  });
};

AudioPlayerPause.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default AudioPlayerPause;